import Vue from 'vue'
import Router from 'vue-router'
import firebase from 'firebase/app'
import 'firebase/auth'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Home',
      meta: { auth: false },
      component: () => import('./views/Home.vue')
    },
    {
      path: '/signin',
      name: 'Sign in',
      meta: { auth: false },
      component: () => import('./views/user/Signin.vue')
    },
    {
      path: '/signup',
      name: 'Sign up',
      meta: { auth: false },
      component: () => import('./views/user/Signup.vue')
    },
    {
      path: '/setting',
      name: 'setting',
      meta: { auth: true },
      component: () => import('./views/user/Setting.vue')
    },
    {
      path: '/mail',
      name: 'mail',
      meta: { auth: false },
      component: () => import('./views/user/MailAction.vue')
    },
    {
      path: '/school',
      name: 'school',
      meta: { auth: true },
      component: () => import('./views/admin/School.vue')
    },
    {
      path: '/account',
      name: 'account',
      meta: { auth: true },
      component: () => import('./views/admin/Account.vue')
    },
    {
      path: '/users',
      name: 'users',
      meta: { auth: true },
      component: () => import('./views/admin/Users.vue')
    },
    {
      path: '/students',
      name: 'Students',
      meta: { auth: true },
      component: () => import('./views/student/Students.vue')
    },
    {
      path: '/chat',
      name: 'Chat',
      meta: { auth: true },
      component: () => import('./views/chat/Chat.vue')
    },
    {
      path: '/schedule',
      name: 'Schedule',
      meta: { auth: true },
      component: () => import('./views/schedule/Main.vue')
    },
    {
      path: '/progress',
      name: 'Progress',
      meta: { auth: true },
      component: () => import('./views/metrics/MainActs.vue'),
      props: { view: true }
    },
    {
      path: '/plan',
      name: 'Plan',
      meta: { auth: true },
      component: () => import('./views/metrics/MetricsPlan.vue'),
      props: { view: true }
    },
    {
      path: '/drive',
      name: 'drive',
      meta: { auth: true },
      component: () => import('./views/google/GoogleDrive.vue')
    },
    {
      path: '/share',
      name: 'share',
      meta: { auth: true },
      component: () => import('./views/google/GoogleDrive.vue')
    },
    {
      path: '/sandbox',
      name: 'Sandbox',
      meta: { auth: true },
      component: () => import('./views/admin/Sandbox.vue')
    },
    {
      path: '/contact',
      name: 'Contact',
      meta: { auth: false },
      component: () => import('./views/user/Contact.vue')
    },
    {
      path: '/notice',
      name: 'Notice',
      meta: { auth: true },
      component: () => import('./views/notice/Notice.vue')
    },
    {
      path: '/terms',
      name: 'Terms',
      meta: { auth: false },
      component: () => import('./views/user/Terms.vue')
    },
    {
      path: '/privacy',
      name: 'Privacy',
      meta: { auth: false },
      component: () => import('./views/user/Privacy.vue')
    },
    {
      path: '/diagnose',
      name: 'Diagnose',
      meta: { auth: true },
      component: () => import('./views/diagnose/Diagnose.vue')
    }
  ]
})

router.beforeEach((to, from, next) => {
  var auth = to.matched.some(record => record.meta.auth)
  let currentUser = firebase.auth().currentUser
  if (auth) {
    if (!currentUser) {
      next({
        path: '/signin'
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
